import { render, staticRenderFns } from "./TrialBanner.vue?vue&type=template&id=52d0f20c&"
import script from "./TrialBanner.vue?vue&type=script&lang=js&"
export * from "./TrialBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports